import { Components } from "appworks/components/components";
import { PromptContent } from "appworks/components/prompt/prompt-content";
import { FadeOut } from "appworks/graphics/animation/base-animations";
import { SpineContainer } from "appworks/graphics/pixi/spine-container";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { Sequence } from "appworks/utils/contracts/sequence";
import { deviceInfo } from "appworks/utils/device-info";
import { TGRMatrixComponent } from "components/tgr-matrix";
import { EpicUIColourComponent } from "epic/components/epic-ui-colour-component";
import { gameLayers } from "game-layers";
import { PartnerConnectCollectCommand } from "partner-connect/commands/partner-connect-collect-command";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { ExitFreespins } from "slotworks/state-machine/standard/states/exit-freespins";

export class TGRExitFreespins extends ExitFreespins {

    public onEnter(): void {
        PartnerConnectCollectCommand().then(() => super.onEnter());
    }

    public onExit(): void {
        const fsSprite = gameLayers.Background.getSprite("bg_fs");
        const fsSpine: SpineContainer = gameLayers.Background.getSpine("fs_spine");

        new Sequence([
            () => new Parallel([
                () => FadeOut(fsSprite, 1000),
                () => FadeOut(fsSpine, 1000),
                () =>  Components.get(EpicUIColourComponent).resetAdjustmentFade(1000)
            ]),
            () => Contract.wrap(() => {
                uiFlags.set(UIFlag.IDLE, true);
                fsSpine.stop();
                fsSpine.visible = false;
                fsSprite.visible = false;
            })
        ]).execute();
    }

    protected resetMatrix(): Contract<void> {
        return Contract.wrap(() => {
            const gameplay = gameState.getCurrentGame();
            const record = gameplay.getCurrentRecord() as SpinRecord;
            if (record.stops) {
                Components.get(TGRMatrixComponent).jump(record.stops, record.reelset);
            } else {
                Components.get(TGRMatrixComponent).jumpToGrid(record.grid);
            }
        });
    }

    protected setupPrompt() {
        return Contract.wrap(() => {
            uiFlags.set(UIFlag.PROMPT, true);
            const freeSpinsWin: number = this.getTotalFreespinsWin();

            this.prompt = new PromptContent(["freespinssummary"], Infinity);

            this.prompt.setText("congratulations", Services.translations.get(`${freeSpinsWin === 0 ? "" : "fsw.con"}`));
            this.prompt.setText("click_tap_play", Services.translations.get(`${deviceInfo.isDesktop ? "clk" : "tap" }.ply`));
            this.prompt.setClickToSkip(true);
            this.prompt.countupText("value", freeSpinsWin, 2000);
        });
    }
}
